<template>
  <div>
    <Menu />
    <div class="container main" v-if="id_funcao == 3">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Visitas no mês"
            description="Visitas realizadas nos últimos 30 dias"
            url="/visitas-domiciliares"
          />
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-md-4">
          <div class="form-group">
            <select
              name=""
              id=""
              v-model="periodo"
              class="form-control"
              @change="onChangePeriodo($event)"
            >
              <option value="" selected disabled>Período</option>
              <option value="30-dias">
                Últimos 30 dias
              </option>
              <option value="mes-atual">Mês Atual</option>
            </select>
          </div>
        </div> -->
        <div class="col-md-12">
          <div class="info-table">
            <div class="info-table-item">
              <p class="fonte">
                <b>Fonte:</b> e-SUS PEC, {{ ultimaAtualizacao }}
              </p>
            </div>
            <div class="info-table-item">
              <b>{{ total_de_visitas_realizadas }} visitas realizadas</b>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <table class="table table-responsive table-striped" id="table">
            <thead class="thead-light">
              <tr>
                <th>Data</th>
                <th>Manhã</th>
                <th>Tarde</th>
                <th>Noite</th>
              </tr>
            </thead>
            <loader-table-skeleton
              :cols="4"
              :rows="10"
              :active="loading"
            ></loader-table-skeleton>
            <tbody v-if="loading == false">
              <tr
                v-for="(item, index) in displayedAtendimentos"
                v-bind:key="index"
              >
                <td>{{ formatDate(item.dt_atendimento) }}</td>
                <td>{{ item.manha !== null ? item.manha : '' }}</td>
                <td>{{ item.tarde !== null ? item.tarde : '' }}</td>
                <td>{{ item.noite !== null ? item.noite : '' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-12">
          <pagination
            :page="page"
            :pages="pages"
            v-on:update:page="page = $event"
          >
          </pagination>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import LoaderTableSkeleton from '@/components/LoaderTableSkeleton.vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import Pagination from '@/components/utils/Pagination'
import utils from '@/mixins/utils.js'

import { mapState } from 'vuex'

export default {
  name: 'VisitasNoMes',
  metaInfo: {
    title: 'eSUS Feedback - Visitas no mês',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    PulseLoader,
    SectionTitle,
    LoaderTableSkeleton,
    Pagination,
  },
  mixins: [utils],
  computed: {
    displayedAtendimentos() {
      this.setPages(this.atendimentos)
      return this.paginate(this.atendimentos)
    },
    ...mapState(['user']),
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
  },
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      atendimentos: [],
      page: 1,
      perPage: 10,
      pages: [],
      total_de_registros_da_tabela: 0,
      total_de_visitas_realizadas: 0,
      periodo: '',
      total: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
    }
  },
  methods: {
    setPages(atendimentos) {
      let numberOfPages = Math.ceil(atendimentos.length / this.perPage)
      this.pages = []
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index)
      }
    },

    paginate(atendimentos) {
      let page = this.page
      let perPage = this.perPage
      let from = page * perPage - perPage
      let to = page * perPage
      return atendimentos.slice(from, to)
    },

    async onChangePeriodo(event) {
      let periodo = event.target.value
      this.loading = true
      try {
        this.loading = true
        let user = await this.$api.post('/app/usuario/auth', {
          cod_ibge: this.cod_ibge,
          id: this.user_id,
        })
        if (user) {
          let response = await this.$api.get(
            '/app/atendimentos-no-mes/profissional/periodo/' +
              user.data.cpf +
              '/' +
              this.cod_ibge +
              '/' +
              periodo
          )
          this.atendimentos = []
          this.atendimentos = response.data
          //calculando a quantidade de visitas realizadas
          let qtd_atendimentos = 0
          for (let i = 0; i < this.atendimentos.length; i++) {
            qtd_atendimentos += parseInt(this.atendimentos[i].qtd_atendimentos)
          }
          this.total_de_visitas_realizadas = qtd_atendimentos
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },

    async carregarDadosIniciais() {
      try {
        this.loading = true
        let user = await this.$api.post('/app/usuario/auth', {
          cod_ibge: this.cod_ibge,
          id: this.user_id,
        })
        if (user) {
          let atendimentos = await this.$api.get(
            `/app/atendimentos-no-mes/profissional/${this.cod_ibge}/acs/${user.data.cpf}`
          )
          if (atendimentos) {
            const date = new Date()
            const currentMonth = date.getMonth() + 1

            this.atendimentos = atendimentos.data.filter((item) => {
              let difference = this.diffDays(item.dt_atendimento)
              if (difference <= 30) {
                return true
              }
              return false
            })

            this.total_de_visitas_realizadas = this.atendimentos.reduce(
              function (acc, obj) {
                let manha = Number(obj.manha) || 0
                let tarde = Number(obj.tarde) || 0
                let noite = Number(obj.noite) || 0
                return acc + manha + tarde + noite
              },
              0
            )
            this.loading = false
          }
        }
      } catch (error) {
        console.log(error)
      }
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.carregarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style></style>
